import { AuthType } from "services/fileObjects/getFilesByPath";

import { Fields as CreateEngineFields } from "components/CreateEngine/CreateEngine";

import { FormatingFields } from "./FormatData/schema";
import { ExistingTableMapData } from "./MapData/ExistingTable/types";
import { ExistingTableMapDataMultifile } from "./MapData/ExistingTableMultifile/types";
import { WizardMapData } from "./MapData/Table/types";

export const CREATE_NEW_ENGINE = "__FIREBOLT_INTERNAL_NEW_ENGINE__";

export const CREATE_NEW_DATABASE = "__FIREBOLT_INTERNAL_NEW_DATABASE__";
export const CREATE_NEW_TABLE = "__FIREBOLT_INTERNAL_NEW_TABLE__";

export const NEW_COLUMN = {
  name: "column",
  type: "text",
  included: false,
  additionalColumn: true,
  data: [] as unknown[],
  dataPreview: "",
  sourceByFile: {},
};

export const NEW_COLUMN_MULTIFILE = {
  name: "column",
  type: "text",
  included: false,
  additionalColumn: true,
  data: [] as unknown[],
  sourceByFile: {},
};

export enum IngestionStep {
  selectAWS = "selectAWS",
  selectData = "selectData",
  formatData = "formatData",
  mapData = "mapData",
  selectDestination = "selectDestination",
  selectEngine = "selectEngine",
  review = "review",
  previewScript = "previewScript",
}

export const SUPPORTED_TYPES = ["csv", "tsv", "parquet"];
export type SupportedTypes = "csv" | "parquet" | "tsv";
export type SupportedQuotes = "DOUBLE_QUOTE" | "SINGLE_QUOTE";
export type SupportedExtensions =
  | "csv"
  | "csv.gz"
  | "csv.snp"
  | "csv.snappy"
  | "gz.csv"
  | "snp.csv"
  | "snappy.csv"
  | "parquet"
  | "parquet.gz"
  | "parquet.snp"
  | "parquet.snappy"
  | "gz.parquet"
  | "snp.parquet"
  | "snappy.parquet";

export type SelectAWSStep = {
  authType: AuthType;
  key: string;
  secret: string;
  iamRole: string;
  storageUrl: string;
};

export type SelectEngineStep = {
  type?: string;
  engine?:
    | CreateEngineFields
    | {
        engineName: string;
      };
};

export type DataFile = {
  name: string;
  extension: SupportedTypes;
  url: string;
  compression: string;
};

export type SelectDataStep = {
  selectedFiles?: Set<string>;
  files: DataFile[];
};

export type SelectDestinationStep = {
  type: string | null;
  database?: string;
  table?: string;
  createPayload?: {
    databaseName?: string;
    tableName?: string;
  };
};

export type PreviewData = {
  meta: {
    name: string;
    type: string;
  }[];
  data: Record<string, unknown>[];
  error: any;
};

export type FormatDataStep = {
  useDefaultErrorSettings: boolean;
  useDefaultFormatSettings: boolean;
  extension: SupportedTypes;
  format: FormatingFields["formatSettings"];
  error: {
    errorFile: string;
    authType: AuthType;
    key?: string;
    secret?: string;
    iamRole?: string;
    // maxErrors: string;
    maxErrorsPerFile: number;
    // onErrorAction: string;
  };
  previewData: Record<string, PreviewData>;
};

export type MultiFileFormatDataStep = {
  useSameFormatForAllFiles: boolean;
  globalExtension: SupportedTypes;
  globalUseDefaultFormatSettings: boolean;
  globalUseDefaultErrorSettings: boolean;
  globalFormatSettings: FormatingFields["formatSettings"];
  globalErrorSettings: {
    errorFile: string;
    authType: AuthType;
    key: string;
    secret: string;
    iamRole: string;
    maxErrorsPerFile: number;
  };
  fileConfigurations: Record<string, FormatingFields>;
  previewData: Record<string, PreviewData>;
};

export type MapDataStep = {
  data: {
    rows: WizardMapData[];
  };
  primaryIndexes: number[];
  autoPrimaryIndex: boolean;
};

export type MapDataMultifileStep = {
  data: {
    rows: WizardMapData[];
    sourceMapFile: string | null;
    initialSourceMapFile: string;
  };
  primaryIndexes: number[];
  autoPrimaryIndex: boolean;
};

export type MapExistingTableStep = {
  data: ExistingTableMapData[] | ExistingTableMapDataMultifile[];
  mapType: MapType | null;
};

export type WizardDataType = {
  [IngestionStep.selectAWS]: SelectAWSStep;
  [IngestionStep.selectEngine]?: SelectEngineStep;
  [IngestionStep.selectData]?: SelectDataStep;
  [IngestionStep.selectDestination]?: SelectDestinationStep;
  [IngestionStep.formatData]?: MultiFileFormatDataStep;
  [IngestionStep.mapData]?:
    | MapDataStep
    | MapExistingTableStep
    | MapDataMultifileStep;
  [IngestionStep.review]?: undefined;
  [IngestionStep.previewScript]?: undefined;
};

export type InitialDataType =
  | SelectAWSStep
  | SelectEngineStep
  | SelectDataStep
  | SelectDestinationStep
  | FormatDataStep;

export enum MapType {
  name = "name",
  index = "index",
}
